import { Frame, Reveal, Label, Headline } from "./SlideKit";

export const Slide6 = () => (
  <Frame num="06" section="Authority & Content System">
    <Headline>
      Robert establishes the authority. <span className="text-neutral-500">A diversified network expands the reach.</span>
    </Headline>
    <div className="mt-12 max-w-5xl grid lg:grid-cols-2 gap-12">
      <Reveal delay={0.4}>
        <Label className="mb-4">One Anchor Video → Eight Assets</Label>
        <div className="border border-neutral-800 p-4 inline-block text-white mb-4">
          Robert — Long-form Anchor <span className="font-mono text-[10px] text-[#dd6611] ml-2">7+ MIN</span>
        </div>
        <div className="grid grid-cols-2 gap-2">
          {["YouTube video", "Education Hub article", "3–4 short clips", "FB / IG content", "TikTok content", "Newsletter material", "Paid-ad hooks", "Webinar material"].map((a) => (
            <div key={a} className="font-mono text-[10px] tracking-[0.1em] uppercase text-neutral-400 border border-neutral-900 px-3 py-2">{a}</div>
          ))}
        </div>
      </Reveal>
      <Reveal delay={0.6}>
        <Label className="mb-4">Five Layers of Influence</Label>
        <div className="space-y-px bg-neutral-800 border border-neutral-800">
          {[
            ["Robert Thomas", "Clinical center of gravity", true],
            ["Averra clinical team", "Distributed expertise"],
            ["Aligned external experts", "Credibility extension"],
            ["Lifestyle & consumer creators", "Reach & relatability"],
            ["Members & advocates", "Proof & referral"],
          ].map(([t, s, acc], i) => (
            <div key={t} className="bg-[#050505] px-4 py-3 flex items-center gap-4">
              <span className="font-mono text-[10px] text-neutral-600">L{i + 1}</span>
              <span className={acc ? "text-[#dd6611]" : "text-white"}>{t}</span>
              <span className="font-mono text-[9px] tracking-[0.1em] uppercase text-neutral-600 ml-auto hidden sm:block">{s}</span>
            </div>
          ))}
        </div>
        <div className="font-mono text-[10px] tracking-[0.12em] uppercase text-neutral-500 mt-4">
          Creators judged on qualified demand — never follower count
        </div>
      </Reveal>
    </div>
  </Frame>
);

export const Slide7 = () => (
  <Frame num="07" section="The Website & Conversion Hub">
    <Headline>
      Browse like ecommerce. Qualify like healthcare. <span className="text-[#dd6611]">Convert through a human conversation.</span>
    </Headline>
    <div className="mt-12 max-w-5xl">
      <div className="grid grid-cols-5 gap-px bg-neutral-800 border border-neutral-800">
        <Reveal delay={0.4} className="col-span-5 sm:col-span-4 bg-[#050505] p-6">
          <div className="flex items-baseline gap-4">
            <span className="text-4xl font-extralight text-[#dd6611]">80%</span>
            <span className="text-white text-lg">Conversion Hub</span>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            {["Concierge", "GLP-1 & metabolic", "Peptides", "Hormones", "Diagnostics", "Performance", "Local pages", "Applications"].map((t) => (
              <span key={t} className="font-mono text-[10px] tracking-[0.1em] uppercase text-neutral-400 border border-neutral-900 px-3 py-1.5">{t}</span>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.55} className="col-span-5 sm:col-span-1 bg-[#050505] p-6">
          <div className="text-2xl font-extralight text-neutral-400">20%</div>
          <div className="text-white mt-1">Education Hub</div>
          <div className="font-mono text-[9px] tracking-[0.1em] uppercase text-neutral-600 mt-3">Articles · Videos · Webinars · SEO / AEO</div>
        </Reveal>
      </div>
      <Reveal delay={0.75} className="grid sm:grid-cols-2 gap-px bg-neutral-800 border border-neutral-800 border-t-0">
        <div className="bg-[#050505] px-6 py-4">
          <Label className="text-[#dd6611]">Medical Rule</Label>
          <div className="text-sm text-neutral-400 font-light mt-2">No “Add to Cart” for prescriptions — apply, speak with the team, determine clinical fit.</div>
        </div>
        <div className="bg-[#050505] px-6 py-4">
          <Label>Supplement Commerce Lane</Label>
          <div className="text-sm text-neutral-400 font-light mt-2">Separate ecommerce lane — cart, checkout, subscriptions, replenishment.</div>
        </div>
      </Reveal>
    </div>
  </Frame>
);

export const Slide8 = () => (
  <Frame num="08" section="Customer Journey & Value Ladder">
    <Headline>
      Concierge is the destination. <span className="text-neutral-500">The value ladder creates multiple ways to begin.</span>
    </Headline>
    <div className="mt-12 max-w-5xl">
      <Reveal delay={0.4} className="grid sm:grid-cols-2 gap-px bg-neutral-800 border border-neutral-800">
        <div className="bg-[#050505] p-5">
          <Label className="text-[#dd6611]">Ready Now</Label>
          <div className="font-mono text-[11px] tracking-[0.12em] text-neutral-300 mt-3">
            APPLICATION <span className="text-[#dd6611]">→</span> WELCOME CALL <span className="text-[#dd6611]">→</span> CONCIERGE
          </div>
        </div>
        <div className="bg-[#050505] p-5">
          <Label>Not Ready</Label>
          <div className="font-mono text-[11px] tracking-[0.12em] text-neutral-300 mt-3">
            ENTRY OFFER <span className="text-[#dd6611]">→</span> NURTURE 7–45D <span className="text-[#dd6611]">→</span> CONCIERGE
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.6} className="mt-10">
        <Label className="mb-5">The Value Ladder</Label>
        <div className="flex items-end gap-1 h-36">
          {["Free education", "Supplements", "Assessments", "Programs", "Services", "Concierge", "Concierge Plus", "Recurring care"].map((s, i) => (
            <div key={s} className="flex-1 flex flex-col justify-end h-full group">
              <div
                className={`w-full border border-neutral-800 ${i >= 5 ? "bg-[#dd6611]/15 border-[#dd6611]/60" : "bg-neutral-950"}`}
                style={{ height: `${22 + i * 11}%` }}
              />
              <div className="font-mono text-[8px] sm:text-[9px] tracking-[0.06em] uppercase text-neutral-500 mt-2 leading-tight">{s}</div>
            </div>
          ))}
        </div>
      </Reveal>
      <Reveal delay={0.85} className="mt-8 border-t border-neutral-800 pt-4">
        <Label>RAVE underneath it all — execution, tracking, retention</Label>
      </Reveal>
    </div>
  </Frame>
);

export const Slide9 = () => (
  <Frame num="09" section="Economics & Launch KPIs">
    <Headline>
      Capacity sets the ceiling. <span className="text-[#dd6611]">CAC and ad spend set the pace to fill it.</span>
    </Headline>
    <div className="mt-10 max-w-5xl">
      <Label className="mb-4">Current Clinical Capacity — Thomas Medical</Label>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-800 border border-neutral-800">
        {[
          ["4", "Current Nurses"],
          ["100", "Patients / Nurse"],
          ["$5,000", "Annual Revenue / Patient"],
          ["$500K", "Annual Revenue / Nurse"],
        ].map(([v, l], i) => (
          <Reveal key={l} delay={0.4 + i * 0.1} className="bg-[#050505] p-5">
            <div className="text-3xl font-extralight text-[#dd6611]">{v}</div>
            <div className="font-mono text-[9px] tracking-[0.15em] uppercase text-neutral-500 mt-2">{l}</div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.75} className="mt-3 border border-[#dd6611]/40 bg-[#dd6611]/5 px-5 py-3">
        <span className="font-mono text-[11px] tracking-[0.08em] text-neutral-300">
          4 nurses <span className="text-[#dd6611]">×</span> 100 patients <span className="text-[#dd6611]">×</span> $5,000 <span className="text-[#dd6611]">=</span> <span className="text-white">$2.0M annual revenue at full capacity</span>
        </span>
      </Reveal>

      <Reveal delay={0.85} className="mt-8">
        <Label className="mb-3">Ad Spend to Hit the 75–100 New Customers / Month Goal</Label>
        <div className="grid grid-cols-5 font-mono text-[9px] sm:text-[10px] tracking-[0.08em] uppercase text-neutral-500 border-b border-neutral-800 pb-2">
          <span>CAC</span>
          <span>75/mo · Monthly</span><span>75/mo · Annual</span>
          <span>100/mo · Monthly</span><span>100/mo · Annual</span>
        </div>
        {[
          ["$150", "$11,250", "$135,000", "$15,000", "$180,000"],
          ["$250", "$18,750", "$225,000", "$25,000", "$300,000"],
          ["$350", "$26,250", "$315,000", "$35,000", "$420,000"],
          ["$450", "$33,750", "$405,000", "$45,000", "$540,000"],
        ].map((row, i) => (
          <div key={i} className="grid grid-cols-5 font-mono text-[10px] sm:text-[11px] text-neutral-300 border-b border-neutral-900 py-2.5">
            {row.map((c, j) => (
              <span key={j} className={j === 0 ? "text-[#dd6611]" : ""}>{c}</span>
            ))}
          </div>
        ))}
      </Reveal>
      <Reveal delay={1.0} className="mt-5">
        <Label>Benchmarks — CPL $5–12 · Lead→Call 40–50% · Show 90%+ · Show→Customer 75%+ · Lead→Customer ≈30%</Label>
      </Reveal>
    </div>
  </Frame>
);

export const SlideCapacity = () => (
  <Frame num="10" section="Capacity Scaling — Nurses Follow Demand">
    <Headline>
      Four nurses is the starting line, not the ceiling. <span className="text-[#dd6611]">Headcount scales with demand.</span>
    </Headline>
    <div className="mt-10 max-w-5xl">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-neutral-800 border border-neutral-800">
        {[
          ["1 : 100", "Nurse : Patients"],
          ["~5 mo", "4 nurses fill at 75/mo"],
          ["+1 nurse", "per 100 new patients"],
          ["$500K", "Capacity added / nurse"],
        ].map(([v, l], i) => (
          <Reveal key={l} delay={0.4 + i * 0.1} className="bg-[#050505] p-5">
            <div className="text-3xl font-extralight text-[#dd6611]">{v}</div>
            <div className="font-mono text-[9px] tracking-[0.15em] uppercase text-neutral-500 mt-2">{l}</div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.8} className="mt-8">
        <Label className="mb-3">Hiring Runway — Nurses On Staff to Stay Ahead of Enrollment</Label>
        <div className="grid grid-cols-5 font-mono text-[9px] sm:text-[10px] tracking-[0.08em] uppercase text-neutral-500 border-b border-neutral-800 pb-2">
          <span>Timeline</span>
          <span>Patients @ 75/mo</span><span>Nurses @ 75/mo</span>
          <span>Patients @ 100/mo</span><span>Nurses @ 100/mo</span>
        </div>
        {[
          ["Launch", "0", "4", "0", "4"],
          ["Month 4", "300", "4", "400", "4"],
          ["Month 6", "450", "5", "600", "6"],
          ["Month 9", "675", "7", "900", "9"],
          ["Month 12", "900", "9", "1,200", "12"],
        ].map((row, i) => (
          <div key={i} className="grid grid-cols-5 font-mono text-[10px] sm:text-[11px] text-neutral-300 border-b border-neutral-900 py-2.5">
            {row.map((c, j) => (
              <span key={j} className={j === 0 ? "text-[#dd6611]" : j === 2 || j === 4 ? "text-white" : ""}>{c}</span>
            ))}
          </div>
        ))}
      </Reveal>

      <Reveal delay={1.05} className="mt-3 border border-[#dd6611]/40 bg-[#dd6611]/5 px-5 py-3">
        <span className="font-mono text-[11px] tracking-[0.08em] text-neutral-300">
          By month 12 <span className="text-[#dd6611]">→</span> <span className="text-white">9 nurses / $4.5M</span> at 75/mo, or <span className="text-white">12 nurses / $6.0M</span> at 100/mo. Hire ahead of the fill line so capacity never caps growth.
        </span>
      </Reveal>
    </div>
  </Frame>
);

export const Slide10 = () => (
  <Frame num="11" section="Execution Roadmap & Decisions">
    <Headline>
      Build the system in Pinehurst. Prove the economics. <span className="text-neutral-500">Then scale the playbook.</span>
    </Headline>
    <div className="mt-12 max-w-5xl">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-px bg-neutral-800 border border-neutral-800">
        {[
          ["Foundation", "Offer, pricing, compliance, tracking"],
          ["Pinehurst Cell", "Website, funnels, Welcome Call"],
          ["Content Layer", "Education Hub, cadence, creators"],
          ["NC Scale", "Raleigh, Charlotte, Wilmington"],
          ["State Replication", "Licensed playbook deployment"],
        ].map(([t, s], i) => (
          <Reveal key={t} delay={0.4 + i * 0.1} className="bg-[#050505] p-5 min-h-[120px]">
            <div className="font-mono text-[10px] text-[#dd6611]">S{i + 1}</div>
            <div className="text-white mt-2 text-sm sm:text-base">{t}</div>
            <div className="font-mono text-[9px] tracking-[0.08em] uppercase text-neutral-600 mt-2 leading-relaxed">{s}</div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.9} className="mt-8 border border-[#dd6611]/50 p-6">
        <Label className="text-[#dd6611] mb-4">Decisions Required Now</Label>
        <div className="grid sm:grid-cols-2 gap-x-10 gap-y-2">
          {[
            "First highest-priority customer",
            "First urgent problem to lead with",
            "Minimum viable launch offer",
            "Concierge / Plus pricing & inclusions",
            "Marketing start vs. acquisition timing",
            "Medical, legal & claims ownership",
            "Call volume & member capacity",
            "Connected technology stack",
          ].map((d, i) => (
            <div key={d} className="flex gap-3 text-sm text-neutral-400 font-light">
              <span className="font-mono text-[10px] text-neutral-600 pt-0.5">0{i + 1}</span>{d}
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </Frame>
);

export const SlideClosing = () => (
  <div className="w-full h-full flex flex-col justify-center px-8 sm:px-16 lg:px-24">
    <Reveal>
      <Label className="text-[#dd6611]">The Connected Story</Label>
    </Reveal>
    <Reveal delay={0.2}>
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-light tracking-tight text-white leading-snug max-w-4xl mt-8">
        Robert earns trust. X Scale turns trust into demand. Funnels turn demand into Welcome Calls. Averra converts prospects into Concierge. <span className="text-[#dd6611]">RAVE creates the outcomes that fuel the next cycle.</span>
      </h1>
    </Reveal>
    <Reveal delay={0.5} className="mt-14 border-t border-neutral-800 pt-6 max-w-4xl">
      <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-neutral-400">
        Authority <span className="text-[#dd6611]">→</span> Demand <span className="text-[#dd6611]">→</span> Welcome Call <span className="text-[#dd6611]">→</span> Concierge <span className="text-[#dd6611]">→</span> Outcomes <span className="text-[#dd6611]">→</span> Referral
      </div>
    </Reveal>
    <Reveal delay={0.7} className="mt-10">
      <Label>Questions — speak at any time, or type into the chat box</Label>
    </Reveal>
  </div>
);
